const SYMBOLS_DATA = {
  atm_sign: '🏧',
  litter_in_bin_sign: '🚮',
  potable_water: '🚰',
  wheelchair_symbol: '♿',
  mens_room: '🚹',
  womens_room: '🚺',
  restroom: '🚻',
  baby_symbol: '🚼',
  water_closet: '🚾',
  passport_control: '🛂',
  customs: '🛃',
  baggage_claim: '🛄',
  left_luggage: '🛅',
  warning: '⚠',
  children_crossing: '🚸',
  no_entry: '⛔',
  prohibited: '🚫',
  no_bicycles: '🚳',
  no_smoking: '🚭',
  no_littering: '🚯',
  non_potable_water: '🚱',
  no_pedestrians: '🚷',
  no_mobile_phones: '📵',
  no_one_under_eighteen: '🔞',
  radioactive: '☢',
  biohazard: '☣',
  up_arrow: '⬆',
  up_right_arrow: '↗',
  right_arrow: '➡',
  down_right_arrow: '↘',
  down_arrow: '⬇',
  down_left_arrow: '↙',
  left_arrow: '⬅',
  up_left_arrow: '↖',
  up_down_arrow: '↕',
  left_right_arrow: '↔',
  right_arrow_curving_left: '↩',
  left_arrow_curving_right: '↪',
  right_arrow_curving_up: '⤴',
  right_arrow_curving_down: '⤵',
  clockwise_vertical_arrows: '🔃',
  counterclockwise_arrows_button: '🔄',
  back_arrow: '🔙',
  end_arrow: '🔚',
  on_arrow: '🔛',
  soon_arrow: '🔜',
  top_arrow: '🔝',
  place_of_worship: '🛐',
  atom_symbol: '⚛',
  om: '🕉',
  star_of_david: '✡',
  wheel_of_dharma: '☸',
  yin_yang: '☯',
  latin_cross: '✝',
  orthodox_cross: '☦',
  star_and_crescent: '☪',
  peace_symbol: '☮',
  menorah: '🕎',
  dotted_six_pointed_star: '🔯',
  khanda: '🪯',
  aries: '♈',
  taurus: '♉',
  gemini: '♊',
  cancer: '♋',
  leo: '♌',
  virgo: '♍',
  libra: '♎',
  scorpio: '♏',
  sagittarius: '♐',
  capricorn: '♑',
  aquarius: '♒',
  pisces: '♓',
  ophiuchus: '⛎',
  shuffle_tracks_button: '🔀',
  repeat_button: '🔁',
  repeat_single_button: '🔂',
  play_button: '▶',
  fast_forward_button: '⏩',
  next_track_button: '⏭',
  play_or_pause_button: '⏯',
  reverse_button: '◀',
  fast_reverse_button: '⏪',
  last_track_button: '⏮',
  upwards_button: '🔼',
  fast_up_button: '⏫',
  downwards_button: '🔽',
  fast_down_button: '⏬',
  pause_button: '⏸',
  stop_button: '⏹',
  record_button: '⏺',
  eject_button: '⏏',
  cinema: '🎦',
  dim_button: '🔅',
  bright_button: '🔆',
  antenna_bars: '📶',
  wireless: '🛜',
  vibration_mode: '📳',
  mobile_phone_off: '📴',
  female_sign: '♀',
  male_sign: '♂',
  transgender_symbol: '⚧',
  multiply: '✖',
  plus: '➕',
  minus: '➖',
  divide: '➗',
  heavy_equals_sign: '🟰',
  infinity: '♾',
  double_exclamation_mark: '‼',
  exclamation_question_mark: '⁉',
  red_question_mark: '❓',
  white_question_mark: '❔',
  white_exclamation_mark: '❕',
  red_exclamation_mark: '❗',
  wavy_dash: '〰',
  currency_exchange: '💱',
  heavy_dollar_sign: '💲',
  medical_symbol: '⚕',
  recycling_symbol: '♻',
  fleur_de_lis: '⚜',
  trident_emblem: '🔱',
  name_badge: '📛',
  japanese_symbol_for_beginner: '🔰',
  hollow_red_circle: '⭕',
  check_mark_button: '✅',
  check_box_with_check: '☑',
  check_mark: '✔',
  cross_mark: '❌',
  cross_mark_button: '❎',
  curly_loop: '➰',
  double_curly_loop: '➿',
  part_alternation_mark: '〽',
  eight_spoked_asterisk: '✳',
  eight_pointed_star: '✴',
  sparkle: '❇',
  copyright: '©',
  registered: '®',
  trade_mark: '™',
  splatter: '🫟',
  keycap_hash: '#️⃣',
  keycap_star: '*️⃣',
  keycap_0: '0️⃣',
  keycap_1: '1️⃣',
  keycap_2: '2️⃣',
  keycap_3: '3️⃣',
  keycap_4: '4️⃣',
  keycap_5: '5️⃣',
  keycap_6: '6️⃣',
  keycap_7: '7️⃣',
  keycap_8: '8️⃣',
  keycap_9: '9️⃣',
};

export default SYMBOLS_DATA;
